import React from 'react';
import { isInGroupSuggestion } from '../../../typeGuards';
import { escapeRegExp } from '../../../utils';
export default function SectionItemText({ item, query, highlightSearchTerm, }) {
    const itemText = isInGroupSuggestion(item) ? item.groupName : item.value;
    if (highlightSearchTerm) {
        const queryRegex = new RegExp(`(${escapeRegExp(query)})`, 'gi');
        const queryIncludedInText = queryRegex.test(itemText);
        if (query && queryIncludedInText) {
            const splitText = itemText.split(queryRegex);
            return (React.createElement(React.Fragment, null, splitText.map((split, index) => {
                // eslint-disable-next-line react/no-array-index-key
                if (queryRegex.test(split))
                    return React.createElement("b", { key: `matched-word-${index}` }, split);
                return split;
            })));
        }
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return React.createElement(React.Fragment, null, itemText);
}
